import { AxiosResponse } from "axios";
import React from "react";
import $ from "jquery";
import ReactDOM from "react-dom";

import { IDataRepr } from "../../../intelws_portal/constructs/elements/Table";
import { get, post, getCancelToken } from "../../../intelws_portal/utils/backendInterface";
import ModalDropDown from "../../../intelws_portal/constructs/modal/ModalDropDown";
import ModalFilePicker from "../../../intelws_portal/constructs/modal/ModalFilePicker";
import ModalFooter from "../../../intelws_portal/constructs/modal/ModalFooter";
import ModalHeader from "../../../intelws_portal/constructs/modal/ModalHeader";

import { parseQueryResponseOnFail, parseQueryResponseOnSuccess } from "../../../declarations/common_utils";
import ModalCheckbox from "../../../intelws_portal/constructs/modal/ModalCheckbox";
import ModalInputText from "../../../intelws_portal/constructs/modal/ModalInputText";

interface IManualDocumentsConfigRepr {
    access_options: string[],
    access_values: number[],
    is_user: boolean
}

interface IFetchManualDocumentsAddConfig extends AxiosResponse {
    data: IManualDocumentsConfigRepr
}

interface IFetchManualDocumentInfo extends AxiosResponse {
    data: {
        access_value: number,
        file_name: string
    }
}

interface IPostManualDocumentsTransfer extends AxiosResponse {
    data: {
        data: IDataRepr,
        old_access: string,
        new_access: string,
    }
}

export interface IModalManualTaskUploadProps {
    userId: number,
    taskId: number,
    taskFileId: number,
    closeModal: () => void,
    mutator: (data?: IDataRepr, oldAccess?: string, newAccess?: string, success?: string[], fail?: string[]) => void
}

function ModalManualTaskFileTransfer(props: IModalManualTaskUploadProps) {
    const ENDPOINT = "/api/manualtasklist/";
    const [config, setConfig] = React.useState<IManualDocumentsConfigRepr | undefined>();

    const [accessValue, setAccessValue] = React.useState(-1);
    const [fileName, setFileName] = React.useState("");
    const [fileNameWithoutExt, setFileNameWithoutExt] = React.useState("");
    const [fileNameExtOnly, setFileNameExtOnly] = React.useState("");
    const [inTransit, setInTransit] = React.useState(false);

    const cancelTokenSource = React.useRef(getCancelToken());

    React.useEffect(() => {
        let queryParams = {
            section: "manual_documents_add_config"
        }
        const requestResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchManualDocumentsAddConfig>;
        requestResponse.then((response) => {
            setConfig(response.data);
            setAccessValue(response.data.access_values[0]);
        })
        return () => {
            cancelTokenSource.current.cancel();
        }
    }, [])

    React.useEffect(() => {
        if (props.taskFileId != -1) {
            const queryParams = {
                section: "manual_documents_info",
                user_id: props.userId,
                task_tracking_id: props.taskId,
                file_id: props.taskFileId
            }

            const requestResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchManualDocumentInfo>;

            requestResponse.then((response) => {
                setAccessValue(response.data.access_value);
                setFileName(response.data.file_name);
                const fileNameSplit = splitFileName(response.data.file_name);
                setFileNameWithoutExt(fileNameSplit.name);
                setFileNameExtOnly(fileNameSplit.extension);
            })
        }

    }, [props.taskFileId])

    React.useEffect(() => {
        $("#manualTaskFileTransferModal").on("hidden.bs.modal", clearForm)
        return () => {
            $("#manualTaskFileTransferModal").off("hidden.bs.modal");
        }
    }, [config])

    function splitFileName(filename: string) {
        const lastDotIndex = filename.lastIndexOf(".");

        // No dot or dot is the first character (e.g. ".env")
        if (lastDotIndex <= 0 || lastDotIndex === filename.length - 1) {
            return {
            name: filename,
            extension: "",
            };
        }

        return {
            name: filename.substring(0, lastDotIndex),
            extension: filename.substring(lastDotIndex + 1),
        };
    }

    function clearForm() {
        if (config != undefined) {
            setAccessValue(config.access_values[0]);
        }
        setInTransit(false);
        props.closeModal();
    }

    function formFieldChange(e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, section: "access" | "file" | "lock", index?: number) {
        if (section == "access") {
            setAccessValue(parseInt(e.target.value));
        }
    }

    function submitForm() {
        let queryParams = {
            section: "transfer_manual_documents",
            user_id: props.userId,
            task_tracking_id: props.taskId,
        }
        let formData = new FormData();
        const newFileName = fileNameWithoutExt + "." + fileNameExtOnly;
        formData.append("file_id", props.taskFileId.toString());
        formData.append("file_name", newFileName.toString());
        formData.append("access", accessValue.toString());
        const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams, true) as Promise<IPostManualDocumentsTransfer>;
        requestResponse.then((response) => {
            let [success, fail] = parseQueryResponseOnSuccess(response);
            props.mutator(response.data.data, response.data.old_access, response.data.new_access, success, fail);
        }).catch((error) => {
            let [success, fail] = parseQueryResponseOnFail(error);
            props.mutator(undefined, undefined, undefined, success, fail);
        })
            .finally(() => {
                $('#manualTaskFileTransferModal').modal("hide");
            })
        setInTransit(true);
    }

    function getAccessDropdown() {
        if (config != undefined && config.access_values.length > 1) {
            return <ModalDropDown options={config.access_options} values={config.access_values}
                value={accessValue} onChange={(e) => formFieldChange(e, "access")} borderBottom />
        }
    }

    function getFileNameInputText() {
        return (
            <p>
                <ModalInputText title="File Name" value={fileNameWithoutExt} onChange={(e) => setFileNameWithoutExt(e.target.value)} />
                .{fileNameExtOnly}
            </p>
        )
    }

    function relativeRender() {
        return (
            <div className="modal fade custom-modal text-center" id="manualTaskFileTransferModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog text-left modal-lg" role="document">
                    <div className="modal-content">
                        <ModalHeader title={"Add Documents"} />
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-8">
                                    <div style={{ marginTop: "10px" }}>
                                        {getFileNameInputText()}
                                    </div>
                                </div>

                                <div className="col-8">
                                    <div style={{ marginTop: "10px" }}>
                                        {getAccessDropdown()}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card" style={{ paddingLeft: '15px' }}>
                            <h6 className="italicFont"> Supported File are: .pdf, .txt, .doc, .docx, .xls, .xlsx, .csv, .jpg, .jpeg, .png</h6>
                            <h6 className="italicFont"> Each File should not exceed 10MB</h6>
                        </div>
                        <ModalFooter saveCallback={submitForm} saveInactive={inTransit} />
                    </div>
                </div>
            </div>
        )
    }

    return ReactDOM.createPortal(relativeRender(), document.getElementById('modal') as Element);
}

export default ModalManualTaskFileTransfer;